// removed by extract-text-webpack-plugin
module.exports = {"header":"header__header__3v_A5","logo":"header__logo__3xoBS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.scss
// module id = 177
// module chunks = 0